import { useEffect, useState } from "react";
import Base from "../../../Base/views/Base";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Typography,
  Grid,
  TextField,
  LinearProgress,
  Stepper,
  Step,
  StepLabel,
  FormControl,
  Stack,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import { CheckCircle, Logout } from "@mui/icons-material";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import { GetECMSExitReasonHelper } from "../../../Ancillary/ECMS/helper/ExitReasonHelper";
import { getEmployeeId, getUserData } from "../../../Base/helper/baseFunctions";
import CustomRating from "../../../Base/views/Rating";
import { DeleteExitRequestHelper, GetAutoCalculatedLWDHelper, GetOneExitEmployeesHelper, updateEmployeeExitRequestHelper } from "../../helper/EcmsHelper";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import ArrowBackButton from "../../../Base/views/ArrowBackButton";
import history from "../../../../../history";

const MyEcms = ({currentMode = "grid", exitEmployeeData, setOpenExitForm, fetchGetEmployee}) => {
  const user = getUserData();
  const userData = currentMode === "admin" ? exitEmployeeData : user;
  const EmployeeFk = currentMode === "admin" ? exitEmployeeData?.employee_id : getEmployeeId();
  const date = new Date();
  const lwdate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
  const initialData = {
    lwd: lwdate,
    exit_reasons_configuration_pk: "",
    feedback_text: "",
    personal_email: userData?.email_id || "",
    personal_phone: userData?.personal_mobile || null,
    feedback_no: 5,
    exit_type: "Termination"
  }
  const [formData, setFormData] = useState(initialData);
  const [feedbackAvail, SetFeedbackAvail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [withdrawalLoading, setWithdrawlLoading] = useState(false);
  const currentStep = formData?.exit_status === "In Progress" ? 1 : formData?.exit_status === "Completed"? 2 : 0;
  const dayCount = calculateDays(formData?.lwd);
  const [errors, setErrors] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [reasonData, setReasonData] = useState({
    load: true,
    values: [],
  });
  const isDisabled = formData?.request_type === "Admin"
  const selfDisabled = formData?.request_type === "Self"
  const steps = isDisabled ? [formData?.exit_type || "Submit Form", "Manager Review", "Final Clearance"] : ["Submit Form", "Manager Review", "Final Clearance"];
  const showSubmitButton = (formData?.request_type === "Admin" && feedbackAvail) ? false : true 

  const handleReason = () => {
    GetECMSExitReasonHelper().then((res) => {
      setReasonData({
        load: false,
        values: res?.data?.data || [],
      });
    });
  };

  const validate = (fieldValues) => {
    let temp = { ...errors };
    if ("personal_phone" in fieldValues) {
      temp.personal_phone =
        !fieldValues.personal_phone?.trim() ? "" : fieldValues.personal_phone?.trim()
          && !/^\d{10}$/.test(fieldValues.personal_phone)
          ? "Invalid Mobile Number."
          : "";
    }
    if ("personal_email" in fieldValues) {
      temp.personal_email =
        !fieldValues.personal_email ? "" : fieldValues.personal_email?.trim() &&
           !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
              fieldValues.personal_email
            )
          ? "Invalid Email."
          : "";
    }
    if ("exit_reasons_configuration_pk" in fieldValues) {
      temp.exit_reasons_configuration_pk =
        !fieldValues.exit_reasons_configuration_pk
          ? "Reason is required"
          : "";
    }
    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };
  const handleInputChange = (event, value) => {
    if (["exit_reasons_configuration_pk"].includes(event)) {
      if (value) {
        setFormData({ ...formData, [event]: value });
      } else {
        setFormData({ ...formData, [event]: "" });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...formData, [event]: value ? value : "" });
    } else {
      setFormData({
        ...formData,
        [event.target.name]: event.target.value,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({
          ...formData,
          [event.target.name]: event.target.value,
        });
    }
  };
  const handleSubmit = (requestBy) => {
    if(!validate(formData)) return;
        setSubmitLoading(true);
        updateEmployeeExitRequestHelper({
            employee_fk: EmployeeFk,
            exit_type: currentMode === "admin" ? formData?.exit_type : "Resignation",
            personal_email: formData?.personal_email,
            personal_phone: formData?.personal_phone,
            lwd: formData?.lwd,
            feedback_text: requestBy === "Admin" ? "" : formData?.feedback_text,
            feedback_no: requestBy === "Admin" ? null : formData?.feedback_no,
            exit_reason_configuration_fk: formData?.exit_reasons_configuration_pk?.exit_reasons_configuration_pk,
            request_type: currentMode === "admin" ? formData?.request_type || "Admin" : (formData?.request_type || "Self") ,
        }).then((res) => {
          if(res?.data?.statuscode === 200) {
            if(currentMode === "admin") {
              setOpenExitForm(false);
              fetchGetEmployee();
            } else {
              const exitResEmp = res?.data?.data?.[0]
              setFormData({
              ...formData, 
              lwd: exitResEmp?.lwd,
              ...(exitResEmp || {}),
              exit_reasons_configuration_pk: exitResEmp?.exit_reason_configuration_fk ? {exit_reasons_configuration_pk: exitResEmp?.exit_reason_configuration_fk, exit_reason: exitResEmp?.exit_reason} : "",
              feedback_no: exitResEmp?.feedback_no ? +exitResEmp?.feedback_no : 5,
            });
            SetFeedbackAvail(exitResEmp?.feedback_text)
            }
          }
          setSubmitLoading(false);
        })
  };
  const handleWithdraw = () => {
        setWithdrawlLoading(true);
        DeleteExitRequestHelper({
            employee_fk: getEmployeeId(),
            entry_type: "withdrawal",
            action_type: "withdra"
        }).then((res) => {
          if(res?.data?.statuscode === 200) {
            fetchData(true);
            setOpenDialog(false);
          }
          setWithdrawlLoading(false);
        })
  };

  const fetchData = async (Withdraw) => {
    try {
      setLoading(true);
      const [lwdRes, exitEmpRes] = await Promise.all([
        GetAutoCalculatedLWDHelper(),
        GetOneExitEmployeesHelper({employee_fk: EmployeeFk}),
      ]);
      const exitResEmp = exitEmpRes?.data?.data?.[0]
      if(Withdraw) {
        setFormData({...initialData,
          lwd: lwdRes?.data?.data?.[0]?.autocalculated_lwd
        })
      } else {
        setFormData({
          ...formData, 
          lwd: lwdRes?.data?.data?.[0]?.autocalculated_lwd || lwdate,
          ...(exitResEmp || {}),
          exit_reasons_configuration_pk: exitResEmp?.exit_reason_configuration_fk ? {exit_reasons_configuration_pk: exitResEmp?.exit_reason_configuration_fk, exit_reason: exitResEmp?.exit_reason} : "",
          feedback_no: exitResEmp?.feedback_no ? +exitResEmp?.feedback_no : 5,
        });
        SetFeedbackAvail(exitResEmp?.feedback_text)
      }
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
  <>
  {currentMode === "grid" ? (
      <Base>
        <Box sx={{ height: "calc(100vh - 65px)", overflowY: "auto", position: "relative" }}>
          <Box mx="auto" display="flex" flexDirection="column" gap={1} mb="10px">
            {/* Exit Process Status Section */}
            <Card
              sx={{
                mb: 2,
                borderRadius: 2,
                boxShadow: 2,
                px: 3,
                pt: 2,
                pb: 0,
                backgroundColor: "#f3edfd",
                position: "relative"
              }}
            >
              <Box sx={{position : "absolute", top: 16, left: 12}}>
                <ArrowBackButton
                    iconSize={18}
                    onClick={() => history.push("/exit-management")}
                />
              </Box>
              <Box textAlign="center">
                <Typography variant="h4" fontWeight="bold">
                  Submit Your Resignation
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  We're here to guide you through this process
                </Typography>
              </Box>
              <CardHeader
                title={
                  <Box display="flex" alignItems="center" gap={1}>
                    <Logout color="primary" fontSize="medium" />
                    <Typography variant="h6" fontWeight="600">
                      Exit Process Status
                    </Typography>
                  </Box>
                }
                sx={{ pb: 0, pt: 0 }}
              />
              <CardContent sx={{ pt: 0.5, pb: 0 }}>
                <Stepper activeStep={currentStep} alternativeLabel>
                  {steps?.map((label, index) => (
                    <Step key={label} completed={index < currentStep}>
                      <StepLabel StepIconComponent={ColorStepIcon}>
                        {label}
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
                <Box mt={1} mb={0}>
                  <LinearProgress
                    variant="determinate"
                    value={(currentStep / (steps?.length - 1)) * 100}
                  />
                </Box>
              </CardContent>
            </Card>
  
            {/* Resignation Form */}
            <Card
              sx={{
                mb: 2,
                borderRadius: 2,
                boxShadow: 2,
                px: 3,
                pt: 0.5,
                pb: 0,
                backgroundColor: "#f3edfd"
              }}
            >
              <CardHeader
                sx={{ pb: 0, pt: 1.5 }}
                title="Resignation Details"
                subheader="Please fill out all required information for your resignation request"
              />
              <CardContent sx={{ pt: 1 }}>
                <Grid container spacing={1.5}>
                  {/* Employee Info */}
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" fontWeight="600">
                      Employee Information
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ px: "0.75rem" }}>
                    <TextField
                      label="Name"
                      fullWidth
                      disabled
                      size="small"
                      value={userData?.name || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ px: "0.75rem" }}>
                    <TextField
                      label="Office Email"
                      fullWidth
                      disabled
                      size="small"
                      value={userData?.office_email || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ px: "0.75rem" }}>
                    <TextField
                      label="Personal Email"
                      fullWidth
                      size="small"
                      name="personal_email"
                      disabled={selfDisabled || !showSubmitButton}
                      value={formData?.personal_email || ""}
                      onChange={handleInputChange}
                      {...(errors?.personal_email && {
                        error: true,
                        helperText: errors?.personal_email,
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ px: "0.75rem" }}>
                    <TextField
                      label="Personal Mobile"
                      fullWidth
                      size="small"
                      type="number"
                      disabled={selfDisabled || !showSubmitButton}
                      value={formData?.personal_phone || ""}
                      name="personal_phone"
                      onChange={handleInputChange}
                      {...(errors?.personal_phone && {
                        error: true,
                        helperText: errors?.personal_phone,
                      })}
                    />
                  </Grid>
  
                  {/* Resignation Info */}
                  <Grid item xs={12} mb={0.5}>
                    <Typography variant="subtitle" fontWeight="600">
                      Resignation Information
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ px: "0.75rem" }}>
                    <FormControl fullWidth>
                      <CommonDatePicker
                        disabled={true}
                        size="small"
                        autoFocus={false}
                        name="lwd"
                        label="Last Working Day"
                        pickerType="date"
                        DefaultDTvalue={formData?.lwd}
                        onKeyDown={(e) => e.preventDefault()}
                        onKeyPress={(e) => e.preventDefault()}
                        pickerFormat="dd/MM/yyyy"
                        textFieldSx={{
                          height: 39,
                          "& .MuiInputBase-root": {
                            height: "39px",
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ px: "0.75rem" }}>
                    <FormControl fullWidth>
                      <SelectableSearch
                        label="Reason"
                        disabled={isDisabled || selfDisabled}
                        value={formData?.exit_reasons_configuration_pk}
                        loading={handleReason}
                        required={true}
                        variant={"outlined"}
                        name="exit_reasons_configuration_pk"
                        fieldLabel="exit_reason"
                        size="small"
                        onChangeEvent={handleInputChange}
                        data={reasonData}
                        {...(errors.exit_reasons_configuration_pk && {
                          error: true,
                          helperText: errors.exit_reasons_configuration_pk,
                        })}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ px: "0.75rem" }}>
                    <TextField
                      label="Feedback"
                      fullWidth
                      size="small"
                      multiline
                      rows={4}
                      disabled={selfDisabled || !showSubmitButton}
                      name="feedback_text"
                      value={formData?.feedback_text}
                      onChange={(e) => {
                        if (e.target.value.length <= 1000) {
                          handleInputChange(e);
                        }
                      }}
                    />
                    <Typography
                      variant="caption"
                      sx={{
                        display: "block",
                        textAlign: "right",
                        color: "#888",
                      }}
                    >
                      {formData?.feedback_text?.length || 0}/1000
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ px: "0.75rem" }}>
                    <Typography gutterBottom fontWeight={600}>
                      How was your experience with {userData?.company_full_name}?
                    </Typography>
                    <CustomRating
                      max={10}
                      name={"feedback_no"}
                      value={formData?.feedback_no}
                      handleInputChange={handleInputChange}
                      readonly={selfDisabled || !showSubmitButton}
                    />
                    </Grid>
                  </Grid>
                    
               <CardActions sx={{ justifyContent: "flex-end", mt: 2 }}>
               { showSubmitButton && 
                  (<Button
                    onClick={() =>handleSubmit("Self")}
                    variant="contained"
                    size="medium"
                    className="mpl-primary-btn"
                    disabled={submitLoading || selfDisabled}
                    startIcon={submitLoading ? <CircularProgress size={18} color="inherit" /> : null}
                  >
                  {formData?.request_type === "Admin" ? "Submit Feedback" : "Submit Resignation"}  
                  </Button>)}
                  { formData?.request_type === "Self" && formData?.exit_status === "In Progress" && 
                  (<Button
                    onClick={() => setOpenDialog(true)}
                    variant="contained"
                    size="medium"
                    className="mpl-primary-btn"
                    disabled={withdrawalLoading}
                    startIcon={withdrawalLoading ? <CircularProgress size={18} color="inherit" /> : null}
                  >
                   Withdraw Resignation
                  </Button>)}
                </CardActions>
              </CardContent>
            </Card>
          </Box>
          <ConfirmationDialog
              title="Withdraw Resignation"
              content={"Are you sure you want to withdraw your resignation request? This action cannot be undone."}
              openDialog={openDialog}
              closeDialog={setOpenDialog}
              OkButtonText="Yes"
              onSubmit={handleWithdraw}
          />
        </Box>
      </Base>
    ) : (
          <Box sx={{position: "relative",}}>
            <Grid container spacing={1.5}>
              {/* Employee Info */}
              <Grid item xs={12}>
                <Typography variant="subtitle1" fontWeight="600">
                  Employee Information
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} sx={{ p: "0.50rem" }}>
                <TextField
                  label="Name"
                  fullWidth
                  disabled
                  size="small"
                  value={userData?.name || ""}
                />
              </Grid>
              <Grid item xs={12} md={6} sx={{ p: "0.50rem" }}>
                <TextField
                  label="Office Email"
                  fullWidth
                  disabled
                  size="small"
                  value={userData?.office_email || ""}
                />
              </Grid>
              <Grid item xs={12} md={6} sx={{ p: "0.50rem" }}>
                <TextField
                  label="Personal Email"
                  fullWidth
                  size="small"
                  name="personal_email"
                  value={formData?.personal_email || ""}
                  onChange={handleInputChange}
                  {...(errors?.personal_email && {
                    error: true,
                    helperText: errors?.personal_email,
                  })}
                />
              </Grid>
              <Grid item xs={12} md={6} sx={{ p: "0.50rem" }}>
                <TextField
                  label="Personal Mobile"
                  fullWidth
                  size="small"
                  type="number"
                  value={formData?.personal_phone || ""}
                  name="personal_phone"
                  onChange={handleInputChange}
                  {...(errors?.personal_phone && {
                    error: true,
                    helperText: errors?.personal_phone,
                  })}
                />
              </Grid>
              {/* Resignation Info */}
              <Grid item xs={12} mb={0.5}>
                <Typography variant="subtitle" fontWeight="600">
                  Resignation Information
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} sx={{ p: "0.50rem" }}>
                <FormControl fullWidth size="small">
                  <InputLabel id="exit-type-label">Exit Type</InputLabel>
                  <Select
                    labelId="exit-type-label"
                    id="exit-type"
                    value={formData?.exit_type}
                    label="Exit Type"
                    name="exit_type"
                    onChange={handleInputChange}
                  >
                    {exitTypes?.map((type) => (
                      <MenuItem key={type.id} value={type.value}>
                        {type.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                
              </Grid>
              <Grid item xs={12} md={6} sx={{ p: "0.50rem" }}>
                <FormControl fullWidth>
                  <SelectableSearch
                    label="Reason"
                    value={formData?.exit_reasons_configuration_pk}
                    loading={handleReason}
                    required={true}
                    variant={"outlined"}
                    name="exit_reasons_configuration_pk"
                    fieldLabel="exit_reason"
                    size="small"
                    onChangeEvent={handleInputChange}
                    data={reasonData}
                    {...(errors.exit_reasons_configuration_pk && {
                      error: true,
                      helperText: errors.exit_reasons_configuration_pk,
                    })}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} sx={{ p: "0.50rem" }}>
                <FormControl fullWidth>
                  <CommonDatePicker
                    size="small"
                    autoFocus={false}
                    name="lwd"
                    label="Last Working Day"
                    pickerType="date"
                    DefaultDTvalue={formData?.lwd}
                    onKeyDown={(e) => e.preventDefault()}
                    onKeyPress={(e) => e.preventDefault()}
                    pickerFormat="dd/MM/yyyy"
                    textFieldSx={{
                      height: 39,
                      "& .MuiInputBase-root": {
                        height: "39px",
                      },
                    }}
                    handleChange={(value) => {
                          handleInputChange({
                            target: {
                              name: "lwd",
                              value: value
                                ? `${value?.getFullYear() +
                                "-" +
                                ("0" + (value?.getMonth() + 1)).slice(-2) +
                                "-" +
                                ("0" + value?.getDate()).slice(-2)
                                }`
                                : "",
                            },
                          })}
                        }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} sx={{ py: "0.50rem" }}>
                  <Box mt={{xs: 0, sm: 0, md: 2}}>
                    <Typography
                      variant="body2"
                      color={dayCount < 0 ? "error" : "text.secondary"}
                    >
                      {dayCount > 0
                        ? `${dayCount} day(s) remaining`
                        : dayCount < 0
                        ? `${Math.abs(dayCount)} day(s) ago`
                        : "Today"}
                    </Typography>
                  </Box>
              </Grid>
            </Grid>
            
            <Stack  direction="row"
              justifyContent="flex-end"
              mt={2}>
              <Button
                onClick={() =>handleSubmit("Admin")}
                variant="contained"
                size="medium"
                className="mpl-primary-btn"
                disabled={submitLoading}
                startIcon={submitLoading ? <CircularProgress size={18} color="inherit" /> : null}
              >
                Submit
              </Button>
            </Stack>
          </Box>
    )}
        <Backdrop
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            position: "absolute",
            borderRadius: "inherit",
          }}
          open={loading}
        >
          <CircularProgress />
        </Backdrop>
  </>
)};
  const exitTypes = [
    { id: 1, label: "Termination", value: "Termination" },
    { id: 2, label: "Retirement", value: "Retirement" },
    { id: 3, label: "Resignation", value: "Resignation" },
  ];
  const calculateDays = (date) => {
    if (date) {
      const selectedDate = new Date(date);
      const today = new Date();

      const selected = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate()
      );
      const current = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
      );

      const diffTime = selected.getTime() - current.getTime();
      const diffDays = diffTime / (1000 * 60 * 60 * 24);
      return diffDays;
    }
  };
const ColorStepIcon = (props) => {
  const { active, completed, icon } = props;

  return (
    <Box
      sx={{
        width: 22,
        height: 22,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "black",
        fontWeight: "600",
        bgcolor: completed ? "" : active ? "primary.main" : "#ffffff",
      }}
    >
      {completed ? (
        <CheckCircle
          sx={{ width: 22, height: 22}}
          fontSize="medium"
          color="primary"
        />
      ) : (
        icon
      )}{" "}
    </Box>
  );
};
export default MyEcms;
